import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import useStates from 'components/Common/Countries/Hooks/useStates';

export default function StateField({ className }) {
  const {
    values: { country: selectedCountryCode, stateName },
    setFieldValue,
    touched,
  } = useFormikContext();
  const states = useStates(selectedCountryCode);

  useEffect(() => {
    if (touched.country && stateName !== '') {
      setFieldValue('stateName', '');
    }
  }, [selectedCountryCode]);

  if (selectedCountryCode === 'US') {
    return (
      <HorizontalSelectField
        name="stateName"
        label="State"
        placeholder={states === null ? 'Loading...' : 'Select State'}
        options={states || []}
        className={className}
        required
      />
    );
  }

  return (
    <HorizontalTextField name="stateName" label="State" required />
  );
}

StateField.propTypes = {
  className: PropTypes.string,
};

StateField.defaultProps = {
  className: '',
};
